import departamentosHttpService from '../_services/departamentosHttpService'
import { GET_DEPARTAMENTOS, GET_DEPARTAMENTO_ESPECIFICO, GET_DEPARTAMENTO_USE, GET_OPERADORES } from './mutation-types'

export default {
  listarTodosDepartamentos: async ({ commit }) => {
    try {
      const response = await departamentosHttpService.getDepartamentos()
      commit(GET_DEPARTAMENTOS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },

  listarDepartamentoEspecifico: async ({ commit }, id) => {
    try {
      const response = await departamentosHttpService.getDepartamentoEspecifico(id)
      commit(GET_DEPARTAMENTO_ESPECIFICO, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },

  listarDepartamentoUse: async({ commit }, id) => {
    try {
      const response = await departamentosHttpService.getDepartamentoUse(id)
      commit(GET_DEPARTAMENTO_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarOperadores: async ({ commit }) => {
    try {
      const response = await departamentosHttpService.getOperadores()
      commit(GET_OPERADORES, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
